<template>
  <div class="default-title">
     <el-form label-width="80px" :model="form" class="list-top-margin templete-dialog" :size="buttonSize">
        <el-row>
          <el-col :span="24" v-if="form.type == '工序'">
            <el-form-item label="工序">
              <el-select v-model="form.processCode" filterable placeholder="请选择" class="full-width">
                 <el-option
                   v-for="item in processList"
                   :key="item.processCode"
                   :label="item.processName"
                   :value="item.processCode">
                 </el-option>
               </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.type == '工艺路线'">
            <el-form-item label="工艺路线">
              <el-select v-model="form.technologyCode" filterable placeholder="请选择" class="full-width">
                 <el-option
                   v-for="item in technologyList"
                   :key="item.technologyCode"
                   :label="item.technologyName"
                   :value="item.technologyCode">
                 </el-option>
               </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="类型">
              <el-radio-group v-model="form.type" @change="resetFiled">
                <el-radio label="工序"></el-radio>
                <el-radio label="工艺路线"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="text-align-center" style="position: relative;">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" class="title" @click="save">确 定</el-button>
      </div>
  </div>
</template>
<script>
import { technologyGetAll,processGetAll } from '@/api/basicData'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      buttonSize:'small',
      form:{
        type:'工序',
      },
      userData:{},
      technologyList:[],
      processList:[],
    }
  },
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
    }
    this.technologyAll()
    this.processAll()
  },
  methods:{
     // 查询所有工艺路线列表
     technologyAll(){
      technologyGetAll(this.userData.factoryId).then(res => {
        if(res.code == 200){
          if(res.data && res.data.length!=0){
            this.technologyList = res.data
          }
        }else{
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    // 查询所有工序
    processAll(){
        processGetAll(this.userData.factoryId).then(res => {
          if(res.code == 200){
            if(res.data && res.data.length!=0){
              this.processList = res.data
            }
          }else{
            this.$message.error(res.msg)
          }
        }).catch(err => {
          this.$message.error(err)
        })
      },
    cancel(){
      this.$emit('done',{type:'cancel'})
    },
    save(){
      var data = JSON.parse(JSON.stringify(this.form))
      if(data.type == '工序'){
        var res = this.processList.filter(function(item){return item.processCode == data.processCode}.bind(this))
        if(res && res.length!=0){
          data.id = res[0]._id
        }
      }else{
        var res = this.technologyList.filter(function(item){return item.technologyCode == data.technologyCode}.bind(this))
        if(res && res.length!=0){
          data.id = res[0]._id
        }
      }
      this.$emit('done',{type:'save',data:data})
    },
    resetFiled(){
      // var type = this.form.type
      // this.form = {}
      // this.form.type = type
    },
  }
}
</script>
<style scoped>
.templete-dialog .el-input-group__append, .el-input-group__prepend{
  color: #fff;
  background-color: #409EFF;
  border-radius: 0 4px 4px 0;
}
.select-count-content{
  position: absolute;
  left: 0;
  top: -45px;
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/views/order/dialogManage/templete-dialog.vue